export const IconBarGraph = ({ ...props }) => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      viewBox="0 0 24 24"
      width="1em"
      height="1em"
      {...props}
    >
      <mask
        id="IconBarGraph_svg__a"
        width={24}
        height={24}
        x={0}
        y={0}
        maskUnits="userSpaceOnUse"
        style={{
          maskType: "alpha",
        }}
      >
        <path d="M0 0h24v24H0z" />
      </mask>
      <g mask="url(#IconBarGraph_svg__a)">
        <path d="M6 20q-.824 0-1.412-.587A1.93 1.93 0 0 1 4 18v-4q0-.825.588-1.412A1.93 1.93 0 0 1 6 12q.824 0 1.412.588Q8 13.175 8 14v4q0 .824-.588 1.413A1.93 1.93 0 0 1 6 20m6 0q-.825 0-1.412-.587A1.93 1.93 0 0 1 10 18V6q0-.824.588-1.412A1.93 1.93 0 0 1 12 4q.825 0 1.412.588Q14 5.175 14 6v12q0 .824-.588 1.413A1.93 1.93 0 0 1 12 20m6 0q-.824 0-1.413-.587A1.93 1.93 0 0 1 16 18v-7q0-.825.587-1.412A1.93 1.93 0 0 1 18 9q.824 0 1.413.588Q20 10.175 20 11v7q0 .824-.587 1.413A1.93 1.93 0 0 1 18 20" />
      </g>
    </svg>
  );
};
